import {apiCurrentRoles} from "./fetcher";
export default function useGetCurrentUserRoles(setRoles: any) {
    const handleGetCurrentUserRoles = () => {
        // Get Current User Roles
        apiCurrentRoles()
            .then((data) => {
                if("data" in data) {
                    if("data" in data.data) {
                        setRoles(data.data.data);
                    }
                }
            })
            .catch((response) => {
                console.error(response);
            });
    }

    return { handleGetCurrentUserRoles };
}